<template>
  <div>
    <form-filtered-select
      :selected-key="selectedVehicle ? selectedVehicle.value : null"
      :options="vehicleOptions"
      :invalid="invalid"
      placeholder="Vehicle"
      @updateDropdownValue="onUpdateValue"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedVehicle: null
    }
  },
  computed: {
    ...mapGetters('vehicle', ['vehicleOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedVehicle && this.value.value !== this.selectedVehicle.value) {
        this.selectedVehicle = this.value
      }
    }
  },
  mounted () {
    this.selectedVehicle = this.value
    this.$watch('selectedVehicle', function () {
      this.$emit('input', this.selectedVehicle)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedVehicle = value
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  &__content-wrapper {
    z-index: 3000 !important;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
